export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"theme-color","content":"#00669F"},{"hid":"description","name":"description","content":"Shop Performance Eyewear for Bike, Run, Snow + Everyday. Featuring 8KO® lens technology & an unrivalled Lifetime Guarantee. B Corp Certified. Order online now."},{"hid":"og:title","property":"og:title","content":"SunGod Performance Sunglasses & Snow Goggles"},{"hid":"og:image","property":"og:image","content":"https://static-bypass.sungod.co/images/banners/020bf7e-crowdfunding-web-banners-steph.jpg"},{"hid":"og:type","property":"og:type","content":"article"},{"hid":"fb:app_id","property":"fb:app_id","content":"1209256785767721"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"},{"rel":"preconnect","href":"https://www.datocms-assets.com"}],"style":[],"script":[{"hid":"pinterest-tag","children":"\n            !function(e){if(!window.pintrk){window.pintrk = function () {\n            window.pintrk.queue.push(Array.prototype.slice.call(arguments))};var\n              n=window.pintrk;n.queue=[],n.version=\"3.0\";var\n              t=document.createElement(\"script\");t.async=!0,t.src=e;var\n              r=document.getElementsByTagName(\"script\")[0];\n              r.parentNode.insertBefore(t,r)}}(\"https://s.pinimg.com/ct/core.js\");\n            pintrk('load', '2613207277751', {em: '<user_email_address>'});\n            pintrk('page');\n          "},{"hid":"reddit-tag","children":"\n            !function(w,d){if(!w.rdt){var p=w.rdt=function(){p.sendEvent?p.sendEvent.apply(p,arguments):p.callQueue.push(arguments)};p.callQueue=[];var t=d.createElement(\"script\");t.src=\"https://www.redditstatic.com/ads/pixel.js\",t.async=!0;var s=d.getElementsByTagName(\"script\")[0];s.parentNode.insertBefore(t,s)}}(window,document);rdt('init','t2_abnjn6bta', {\"useDecimalCurrencyValues\":true,\"aaid\":\"<AAID-HERE>\",\"email\":\"<EMAIL-HERE>\",\"idfa\":\"<IDFA-HERE>\"});rdt('track', 'PageVisit');\n          "},{"src":"https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=JYQBXr","defer":true},{"src":"https://sungod.avln.me/t.js","async":true}],"noscript":[{"hid":"pinterest-no-script","innerHTML":"\n            <img height=\"1\" width=\"1\" style=\"display:none;\" alt=\"\"\n              src=\"https://ct.pinterest.com/v3/?event=init&tid=2613207277751&pd[em]=<hashed_email_address>&noscript=1\" />\n          "}],"title":"SunGod","htmlAttrs":{"lang":"en"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true